import { render, staticRenderFns } from "./RectoratMainPanel.vue?vue&type=template&id=f8087d10&scoped=true&"
import script from "./RectoratMainPanel.vue?vue&type=script&lang=js&"
export * from "./RectoratMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8087d10",
  null
  
)

export default component.exports